import { useTranslation } from 'react-i18next';

import { Input } from '@/shared/ui/input';
import { Icon } from '@/shared/ui/icon';

interface TreeViewFiltersProps {
  query: string;
  onQueryChange: (query: string) => void;
}

/**
 * Search-as-you-type filter row for TreeView (PHX-TREE-01 § 2).
 * Built on the Phoenix `Input` primitive; vpravo ✕ pro zrušení hledání,
 * zobrazené jen když pole není prázdné.
 */
export function TreeViewFilters({ query, onQueryChange }: TreeViewFiltersProps) {
  const { t } = useTranslation('sharedUi');

  return (
    <div className="pb-phx-4">
      <div className="relative">
        <Input
          type="search"
          size="sm"
          placeholder={t('treeView.searchPlaceholder')}
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          aria-label={t('treeView.searchPlaceholder')}
          leadingIcon="search"
          className="pr-6.5 [&::-webkit-search-cancel-button]:hidden"
        />
        {query !== '' && (
          <button
            type="button"
            className="rounded-phx-sm text-phx-text-muted hover:bg-phx-surface-3 hover:text-phx-text absolute top-1/2 right-1.25 flex h-4.5 w-4.5 -translate-y-1/2 cursor-pointer items-center justify-center"
            title={t('treeView.clearSearch')}
            aria-label={t('treeView.clearSearch')}
            onClick={() => onQueryChange('')}
          >
            <Icon name="x" size={10} />
          </button>
        )}
      </div>
    </div>
  );
}
